import { ThemeUICSSObject, spacing } from '@apia/theme';

const renderPivot: ThemeUICSSObject = {
  height: '100%',
  overflow: 'auto',
  '.pvtUi, .pvtTable': {
    borderCollapse: 'collapse',
  },
  '.pivotRenderer__innerWrapper': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #aaa',
    overflow: 'hidden',
    borderRadius: '6px',
    '.chartTitle': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: spacing(3),
      paddingLeft: spacing(5),
      backgroundColor: 'palette.secondary.light',
      color: 'palette.primary.contrastText',
    },

    '.pivotRenderer__container': {
      flexGrow: 1,
      alignItems: 'start',
      justifyContent: 'start',
      // padding: '12px',
      // border: '1px solid #cacaca',
      // background: '#eee',
      overflow: 'auto',
      '&:is(.fullscreen)': {
        overflow: 'none',
      },
      height: '100%',
      display: 'flex',
      '>div': {
        '&:empty': {
          height: '440px',
          width: '1000px',
        },
        width: 'auto',
        display: 'inline-flex',
        flex: '1 0 auto',
        padding: '12px',
        border: '1px solid #999',
        boxShadow: '0px 2px 12px 4px #0002',
        minHeight: 'auto',
        overflow: 'auto',
        '&:is(.fullscreen)': {
          overflow: 'none',
        },
        height: 'fit-content',
        background: 'white',
        '>table': {
          height: '100%',
          width: 'auto',
          '>tbody': {
            height: '100%',
            display: 'table',
            width: '100%',
            '.pvtDropdownValue.pvtDropdownCurrent': {
              padding: '12px',
              borderRadius: 0,
              border: '1px solid black',
            },
            '.pvtAttr': {
              borderRadius: 0,
              background: '#ffffff',
              border: '1px solid #00496c',
              padding: '12px',
              display: 'flex',
              justifyContent: 'space-between',
            },
            '.pvtRenderers': {
              border: '1px solid',
              borderColor: 'palette.border.article',
              padding: '12px',
              minWidth: '20px',
              minHeight: '20px',
              '.pvtDropdown': {
                margin: 0,
                width: '100%',
                '.pvtDropdownValue.pvtDropdownCurrent': {
                  width: '100%',
                },
              },
            },
            '.pvtDropdownIcon': {
              color: 'black',
            },
            '.pvtVals': { padding: '12px' },
            '.pvtOutput': {
              border: '1px solid',
              borderColor: 'palette.border.article',
              paddingRight: '4px',
            },
            '.pvtAxisContainer li': {
              position: 'relative',
              padding: '0',
              '.pvtFilterBox': {
                transform:
                  'translate3d(0px, 0px, 0px) translateY(-60px) !important',
                top: '100%',
              },
            },
            '.pvtAxisContainer, .pvtVals': {
              border: '1px solid',
              borderColor: 'palette.border.article',
            },
            '.pvtDropdownMenu': {
              maxHeight: '300px',
              overflowY: 'scroll',
              width: 'max-content',
            },
            '.pvtAxisContainer.pvtHorizList': {
              padding: '12px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              height: '100%',
              li: {
                position: 'relative',
                padding: '0',
                '.pvtFilterBox': {
                  transform:
                    'translate3d(0px, 0px, 0px) translateY(-60px) !important',
                  top: '100%',
                },
              },
            },
            '.pvtAxisContainer.pvtVertList': {
              padding: '12px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              flexDirection: 'column',
              height: '100%',
              li: {
                position: 'relative',
                padding: '0',
                '.pvtFilterBox': {
                  transform: 'translate3d(0px, 0px, 0px) !important',
                  top: '100%',
                },
              },
            },
            // '.pvtAxisContainer.pvtHorizList li ': {
            //   marginRight: '8px',
            // },
            // '.pvtAxisContainer.pvtVertList li': {
            //   marginBottom: '8px',
            // },
            '>tr:last-of-type': {
              height: '100%',
              display: 'table-row',
              '.pvtOutput': {
                padding: '12px',
              },
              '.pvtOutput table.pvtTable': {
                margin: 0,
              },

              '.pvtOutput table.pvtTable thead tr th, .pvtOutput table.pvtTable tbody tr th':
                {
                  border: '1px solid',
                  borderColor: 'palette.border.article',
                  background: 'palette.secondary.light',
                  fontSize: '16px',
                },
              '.pvtOutput table.pvtTable tbody tr td': {
                border: '1px solid',
                borderColor: 'palette.border.article',
              },
            },
          },
        },
      },
    },
  },
  '.pvtTable td, .pvtTable th': {
    padding: 4,
  },
};

export default renderPivot;
